<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    
   <div>
   <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Newsletter</vs-button>
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <vs-table ref="table" search pagination :max-items="itemsPerPage"  :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
         <vs-th>Log</vs-th>
         <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td  v-if="tr.log.length===0">
                <router-link :to="'/newsletters/'+tr.id" class="text-inherit flex">
                <img :src="tr.image"  alt="" height="120px" width="100px" style="border:1px solid black; padding: 5px;">
                <p class="product-name font-medium truncate flex justify-center items-center ml-5">{{ tr.name }}</p>
                  </router-link>
              </vs-td>
              <vs-td v-else >
                <span class="text-inherit flex">
                <img :src="tr.image" alt="" height="120px" width="100px" style="border:1px solid black; padding: 5px;">
                <p class="product-name font-medium truncate flex justify-center items-center ml-5">{{ tr.name }}</p>
                </span>
              </vs-td>
              <vs-td><vs-chip v-if="tr.log.length>0"><span @click="LogView(tr.log)">View Log</span></vs-chip><p v-else>N/A</p></vs-td>
               <vs-td class="whitespace-no-wrap">
                  <feather-icon v-if="tr.log.length===0" icon="EditIcon" @click="editData(tr)" svgClasses="h-4 w-4" class="mr-2"/>
                  <feather-icon icon="TrashIcon" @click="confirmDeleteRecord(tr)" svgClasses="h-4 w-4" class="mr-2 "/>
                  <feather-icon icon="CopyIcon" @click="DuplicateTemplate(tr)" svgClasses="h-4 w-4" class="mr-2 "/>
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-4 h-4 hover:text-primary stroke-current"  icon="DownloadIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item  @click="DownloadPdf(tr)">
                <span class="flex items-center" > Download PDF
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item  @click="DownloadJPEG(tr)">
                <span class="flex items-center" >Download JPEG</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>
            </vs-tr>
          </tbody>
          <vs-popup class="holamundo"  title="Add Name" :active.sync="DuplicatePopup">
  <vs-row>        
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="TempName" placeholder="Enter Link"></vs-input>
    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button size="small" @click.native="SaveDuplicate">Create</vs-button>
    </vs-col>
</vs-row>
    </vs-popup>
        </template>
    </vs-table>
        <vs-popup class="holamundo"  title=" " :active.sync="LogPopUp">
     <table style="width: 100%">
        <tr>
          <th>Email</th>
          <th>Status</th>
          <th>Sender</th>
        </tr>
        <tr v-for="(log, index) in LogData" :key="index">
          <td>{{ log.user }}</td>
          <td>{{ log.status }}</td>
          <td>{{ log.send_by.username }}</td>
        </tr>
      </table>
      
    </vs-popup>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import {ALL_NEWSLETTERS, REMOVE_TEMPLATE, DUPLICATE_NEWSLETTER, DOWNLOAD_TICKET_ATTACHMENT } from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  // dirName: process.env.VUE_APP_AWS_DIREC,
  dirName: 'newsletters',
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      DeletedItem:null,
      templates:[],
      LogPopUp:false,
      LogData:null,
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      role:null,
      TempName:null,
      DuplicatePopup:false,
      TempData:null,
      activeLoading :false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.templates
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    DownloadPdf (data) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file:`newsletters/P${data.key  }.pdf`
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
          this.get()
        }
        )
    },
    DownloadJPEG (data) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file:`newsletters/${data.key  }.jpeg`
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
          this.get()
        }
        )
    },
    LogView (data) {
      this.LogPopUp = true
      this.LogData = data
    },
    SaveDuplicate () {
      if (this.TempName.length > 0) { 
        const today = new Date()
        const date = `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`
        const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`
        const fileName = `${time}-${date}` + 'Newsletter'
        this.$apollo
          .mutate({
            mutation: DUPLICATE_NEWSLETTER,
            variables: {
              id: this.TempData.id,
              key: fileName,
              name:this.TempName
            }
          })
          .then(response => {
            if (response.data.duplicateNewsletter.status === 'Success') {
              this.DuplicatePopup = false
              this.StatusSuccess()
              this.get()
            }
          }).catch(error => {
            console.log(error)
          })
      } else {
        this.$vs.notify({
          title: 'Newsletter',
          text: 'Name is Required',
          color: 'danger',
          position: 'top-right'
        })
      }        

    },
    DuplicateTemplate (tr) {
      this.TempName = `${tr.name  } copy`
      this.TempData = tr
      this.DuplicatePopup = true
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Failed to Update',
        color: 'success',
        position: 'top-right'
      })
    },
    getdata () {
      this.get()
    },
    addNewData () {
      this.$router.push({ path: '/newsletter/new' })
      // this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    confirmDeleteRecord (template) {
      this.DeletedItem = template
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${template.name} "`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_TEMPLATE,
          variables: {
            id:  this.DeletedItem.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteNewsletterTemplate.status === 'Success') {
            this.StatusSuccess(response.data.deleteNewsletterTemplate.message, response.data.deleteNewsletterTemplate.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Newslette',
        text: status,
        color,
        position: 'top-right'
      })
    },
    loader () {
      this.activeLoading = true
      this.$vs.loading({
        type:'sound'
      })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_NEWSLETTERS
        })
        .then(response => {
          this.templates = response.data.newsletters
          this.activeLoading = false
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.loader()
    this.get()
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

